import { Component } from "react";

import './style.scss';

class CircleButton extends Component {    

    render() {
        return (
            <>                
                <div className={`${this.props.className ? this.props.className : ""} circle-bt`} onClick={this.props.onClick}>{this.props.icon ? this.props.icon : null}</div>
            </>
        )
    }
}

export default CircleButton;